var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDotsNine = function SvgIconDotsNine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12 7.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M19.875 5.625a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M5.625 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M13.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M18.375 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M7.125 18.375a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M12 19.875a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M19.875 18.375a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconDotsNine;